import request from '@/config/axios'

/** 流水类型标签 */
export const WALLET_FLOW_TYPE_LABELS: Record<number, string> = {
  1: '订单收入',
  2: '提现支出',
  3: '调整'
}

/** 师傅钱包 VO（金额单位：分） */
export interface MasterWalletVo {
  masterId: number
  masterName?: string
  masterStatus: number
  balance: number
  totalIncome: number
}

/** 钱包流水 VO（金额单位：分） */
export interface MasterWalletFlowVo {
  id: number
  masterId: number
  masterName?: string
  type: number
  amount: number
  balanceAfter: number
  orderNo?: string
  remark?: string
  createTime?: string
}

export const MasterWalletApi = {
  // 师傅钱包分页（全部师傅，未结算显示 0；师傅姓名模糊）
  getWalletPage: (params: { pageNo?: number; pageSize?: number; masterName?: string }) => {
    return request.get({ url: '/xuanxue/master-wallet/page', params })
  },
  // 钱包流水分页（师傅姓名模糊/类型筛选）
  getFlowPage: (params: { pageNo?: number; pageSize?: number; masterName?: string; type?: number }) => {
    return request.get({ url: '/xuanxue/master-wallet/flow-page', params })
  }
}
